import React from 'react';

import { Box, Flex } from '@chakra-ui/react';
import parse from 'html-react-parser';
import { ANSWER_TYPE_COMPONENTS } from 'screens/performanceReview/ResultPage/components/results/ResultRenderer';

import { TextBodyMedium, TextLabel } from 'uiToolkitV1/Typography';

// Todo: to handle empty case

const PeerAnswer = ({ feedbackText = '', feedbackTextHtml = '', selectedAnswerOptions, question }) => {
  const showFeedbackPlainText = !feedbackTextHtml;
  const hasFeedbackText = feedbackText || feedbackTextHtml;
  const answerType = question?.answerType;
  const answerTypeComp = ANSWER_TYPE_COMPONENTS[answerType]?.component;
  const isFeedbackTextEnabled = question?.enableFeedbackText;

  return (
    <Flex flexDir="column">
      {answerTypeComp && (
        <Box>
          {answerTypeComp && (
            <Box mb={4}>
              <>
                {answerTypeComp({
                  selectedAnswerOptions,

                  answerOptions: question.answerOptions,
                })}
              </>
            </Box>
          )}
        </Box>
      )}

      {isFeedbackTextEnabled && (
        <Flex flexDir="column" mt="16px">
          <TextLabel bold color="text.g2">
            Comments
          </TextLabel>
          <TextBodyMedium mt="2px">
            {!hasFeedbackText && '-'}
            {hasFeedbackText && (showFeedbackPlainText ? feedbackText : parse(feedbackTextHtml ?? ''))}
          </TextBodyMedium>
        </Flex>
      )}
    </Flex>
  );
};

export default PeerAnswer;
